import { Button, Typography } from '@mui/material';

import ChevronRightIcon from '@/components/Icons/ChevronRightIcon';

import { EmptyStateButtonProps } from './types';

function EmptyStateButton({ icon, sx, children, ...rest }: EmptyStateButtonProps) {
  return (
    <Button
      size="large"
      startIcon={icon}
      endIcon={<ChevronRightIcon color="secondary" />}
      sx={{ justifyContent: 'space-between', padding: 2, gap: 1, ...sx }}
      {...rest}
    >
      <Typography variant="h5" flexGrow={1} textAlign="left">
        {children}
      </Typography>
    </Button>
  );
}

export { EmptyStateButton };
